"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6495],{

/***/ 77314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ home_page_CommunityBenefit; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(33082);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
;// CONCATENATED MODULE: ./src/features/home-page/CommunityBenefit/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-gap: 30px;\n\n  @media ",
        " {\n    grid-template-columns: repeat(3, 1fr);\n    padding-top: 30px;\n  }\n\n  @media ",
        " {\n    grid-gap: 60px;\n    padding-top: 50px;\n  }\n\n  [data-name='benefitColumn']:nth-child(1) .fadeInTop {\n    animation-delay: 0.1s;\n  }\n\n  [data-name='benefitColumn']:nth-child(2) .fadeInTop {\n    animation-delay: 0.25s;\n  }\n\n  [data-name='benefitColumn']:nth-child(3) .fadeInTop {\n    animation-delay: 0.4s;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n\n  @media ",
        " {\n    font-size: 28.5px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 17px;\n\n  @media ",
        " {\n    font-size: 19px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var BenefitWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a1ac6896-0"
})(_templateObject(), device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
var BenefitTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    as: "h2",
    align: "center",
    family: "bold",
    mb: "30px"
}).withConfig({
    componentId: "sc-a1ac6896-1"
})(_templateObject1(), device/* default.laptop */.Z.laptop);
var BenefitDescription = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    family: "light",
    align: "center"
}).withConfig({
    componentId: "sc-a1ac6896-2"
})(_templateObject2(), device/* default.laptop */.Z.laptop);


// EXTERNAL MODULE: ./src/features/home-page/styled.ts
var styled = __webpack_require__(24529);
// EXTERNAL MODULE: ./src/features/home-page/constants.ts
var constants = __webpack_require__(22530);
;// CONCATENATED MODULE: ./src/features/home-page/CommunityBenefit/index.tsx









function CommunityBenefit() {
    var ref = (0,react.useState)(false), viewed = ref[0], setViewed = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
        offset: {
            top: 140,
            bottom: 140
        },
        partialVisibility: true,
        onChange: function(v) {
            return setViewed(function(s) {
                return s || v;
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Wrapper */.im, {
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* SectionTitle */.NZ, {
                    className: "fadeInX fadeIn",
                    children: "Keuntungan dari Kebersamaan"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitWrapper, {
                    children: constants/* communityBenefits.map */.o6.map(function(benefit) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            "data-name": "benefitColumn",
                            direction: "column",
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: benefit.image,
                                    alt: benefit.title,
                                    className: (0,clsx_m/* default */.Z)("fadeInTopX", viewed && "fadeInTop"),
                                    style: {
                                        margin: "20px 0",
                                        width: "190px"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    className: "fadeIn fadeInX",
                                    direction: "column",
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitTitle, {
                                            children: benefit.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitDescription, {
                                            children: benefit.description
                                        })
                                    ]
                                })
                            ]
                        }, benefit.title);
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var home_page_CommunityBenefit = (CommunityBenefit);


/***/ }),

/***/ 22530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I0": function() { return /* binding */ listMedia; },
/* harmony export */   "bn": function() { return /* binding */ benefits; },
/* harmony export */   "cr": function() { return /* binding */ keyFeatures; },
/* harmony export */   "ds": function() { return /* binding */ companyLogos; },
/* harmony export */   "o6": function() { return /* binding */ communityBenefits; }
/* harmony export */ });
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);

var prefix = "".concat(constants_app__WEBPACK_IMPORTED_MODULE_0__/* .assetPrefix */ .Vc, "/images");
var keyFeatures = [
    {
        title: "Platform Charting Modern",
        description: "Monitor harga saham dari platform charting kelas professional.",
        imageUrl: "".concat(prefix, "/charting2.webp")
    },
    {
        title: "Data Finansial Yang Lengkap",
        description: "Dukung analisa Anda dengan data terlengkap dan terpercaya.",
        imageUrl: "".concat(prefix, "/financial2.webp")
    },
    {
        title: "Screener Terbaik",
        description: "Cari saham yang layak di investasi dengan mudah.",
        imageUrl: "".concat(prefix, "/screener.webp")
    },
    {
        title: "PE Standard Deviation Band",
        description: "Menunjukkan valuasi saham apakah sedang mahal atau murah secara mudah dan cepat.",
        imageUrl: "".concat(prefix, "/p4.webp")
    }, 
];
var listMedia = [
    {
        name: "Techinasia",
        url: "https://www.techinasia.com/trading-platform-stockbit-gets-funding-from-500-startups",
        image: "".concat(prefix, "/techinasia.webp"),
        height: "55px"
    },
    {
        name: "CNN Indonesia",
        url: "https://www.cnnindonesia.com/teknologi/20150924142517-185-80773/situs-analisis-saham-stockbit-raih-pendanaan-dari-ideosource",
        image: "".concat(prefix, "/CNN_Indonesia.svg"),
        height: "75px"
    },
    {
        name: "Dailysocial",
        url: "https://dailysocial.id/post/stockbit-analisis-saham",
        image: "".concat(prefix, "/DailySocial.png"),
        height: "50px"
    },
    {
        name: "Deal Street Asia",
        url: "https://www.dealstreetasia.com/stories/indonesian-investment-intelligence-platform-stockbit-raises-seed-funding-from-ideosource-13224/",
        image: "".concat(prefix, "/dealstreetasia.jpg"),
        height: "75px"
    }, 
];
var benefits = [
    {
        title: "Komunitas Saham Terbesar",
        image: "".concat(prefix, "/x5.svg"),
        description: "Lebih dari 100,000 investor telah bergabung. Diskusi dan dapatkan analisa saham terbaik langsung dari investor yang berpengalaman."
    },
    {
        title: "Aman & Terpercaya",
        image: "".concat(prefix, "/x6.svg"),
        description: "Hindari investasi bodong. Semua transaksi saham di Stockbit melewati perusahaan sekuritas yang telah didaftar dan diawasi oleh OJK."
    }, 
];
var companyLogos = [
    [
        "".concat(prefix, "/logos-1.svg"),
        "".concat(prefix, "/logos-2.svg"),
        "".concat(prefix, "/logos-3.svg"),
        "".concat(prefix, "/logos-4.svg"),
        "".concat(prefix, "/logos-5.svg"),
        "".concat(prefix, "/logos-6.svg"), 
    ],
    [
        "".concat(prefix, "/logos-7.svg"),
        "".concat(prefix, "/logos-8.svg"),
        "".concat(prefix, "/logos-9.svg"),
        "".concat(prefix, "/logos-10.svg"),
        "".concat(prefix, "/logos-11.svg"),
        "".concat(prefix, "/logos-12.svg"), 
    ], 
];
var communityBenefits = [
    {
        image: "".concat(prefix, "/x1.svg"),
        title: "Lebih Informatif",
        description: "Dapatkan ide investasi yang baik dari hasil diskusi dan analisa saham investor yang berpengalaman."
    },
    {
        image: "".concat(prefix, "/x2.svg"),
        title: "Lebih Cepat",
        description: "Informasi tersebar lebih cepat dengan bantuan komunitas Stockbit. Bersama Stockbit, kamu akan lebih terupdate dengan informasi terkini."
    },
    {
        image: "".concat(prefix, "/x3.svg"),
        title: "Lebih Seru",
        description: "Investasi jadi lebih seru bareng teman dan keluarga kamu. Bagikan strategi kamu untuk saling melengkapi dan nikmati hasilnya bersama."
    }, 
];



/***/ }),

/***/ 24529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NZ": function() { return /* binding */ SectionTitle; },
/* harmony export */   "Vq": function() { return /* binding */ SectionSubtitle; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74575);
/* harmony import */ var _keyframes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16681);
/* eslint-disable indent */ /* eslint-disable space-infix-ops */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 50px 25px;\n  width: 100%;\n  max-width: 1300px;\n\n  @media ",
        " {\n    padding: 50px 30px;\n  }\n\n  @media ",
        " {\n    padding: 50px 0;\n    width: calc(100% - 150px);\n  }\n\n  // animations\n  .scaleUpX {\n    transform: scale(0.9);\n  }\n\n  .fadeInRightX,\n  .fromRightX,\n  .fadeInLeftlongX,\n  .fadeInLeftBorderX,\n  .fadeInLeftX2,\n  .fadeInLeftX,\n  .fadeInX,\n  .fadeInTopX,\n  .fadeInDownX,\n  .scaleUpX {\n    opacity: 0;\n  }\n\n  .fadeInLeftBorderX.on,\n  .fadeInLeftX.on,\n  .fadeInX.on {\n    opacity: 1;\n  }\n\n  .fadeIn {\n    animation-duration: 1s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n  }\n\n  .fromRight {\n    animation-duration: 0.6s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n  }\n\n  .fadeInRight {\n    animation-duration: 1s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n  }\n\n  .fadeInLeft {\n    animation-duration: 0.6s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n  }\n\n  .fadeInLeft2 {\n    animation-duration: 0.6s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n    animation-delay: 0.3s;\n  }\n\n  .fadeInTopX {\n  }\n\n  .fadeInTop {\n    animation-duration: 0.5s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n    transform: translate3d(0, -50px, 0);\n  }\n\n  .fadeInDown {\n    animation-duration: 0.5s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n    transform: translate3d(0, -50px, 0);\n  }\n\n  .fromRightP:nth-child(1) .fromRight {\n    animation-delay: 0.2s;\n  }\n\n  .fromRightP:nth-child(2) .fromRight {\n    animation-delay: 0.35s;\n  }\n\n  .fromRightP:nth-child(3) .fromRight {\n    animation-delay: 0.5s;\n  }\n\n  .fromRightP:nth-child(4) .fromRight {\n    animation-delay: 0.65s;\n  }\n\n  .fromRightP:nth-child(5) .fromRight {\n    animation-delay: 0.8s;\n  }\n\n  .fromRightP:nth-child(6) .fromRight {\n    animation-delay: 0.95s;\n  }\n\n  .scaleUp {\n    animation-duration: 0.6s;\n    animation-fill-mode: forwards;\n    animation-name: ",
        ";\n    transition-timing-function: ease-out;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 36px;\n  text-align: center;\n\n  @media ",
        " {\n    font-size: 6.5vh;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 17px;\n  margin-top: 5vh;\n  text-align: center;\n\n  @media ",
        " {\n    font-size: 18px;\n  }\n\n  @media ",
        " {\n    font-size: 19px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    direction: "column",
    m: "auto",
    as: "section"
}).withConfig({
    componentId: "sc-896b5acc-0"
})(_templateObject(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].tablet */ .Z.tablet, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].laptop */ .Z.laptop, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .fadeIn */ .Ji, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .fromRight */ .hb, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .fadeInRight */ .ER, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .fadeInLeft */ .O2, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .fadeInLeft */ .O2, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .fadeInTop */ .E_, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .fadeInDown */ .d7, _keyframes__WEBPACK_IMPORTED_MODULE_4__/* .scaleUp */ .wK);
var SectionTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    as: "h1",
    family: "bold",
    height: 1,
    m: "0px"
}).withConfig({
    componentId: "sc-896b5acc-1"
})(_templateObject1(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].laptop */ .Z.laptop);
var SectionSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    family: "light",
    height: 1.5
}).withConfig({
    componentId: "sc-896b5acc-2"
})(_templateObject2(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].tablet */ .Z.tablet, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].laptop */ .Z.laptop);



/***/ })

}]);